<template>
  <div class="page">
    <div class="contact-us-block">
      <div class="contact-us-title">
        <title-text title="联系我们"></title-text>
      </div>
      <div class="left">
        <div>
          <p>地址：深圳市南山区高新南<br>深圳湾科技园十栋B座901B</p>
          <hr>
        </div>
        <div>
          <p>24小时咨询热线： 17724731490</p>
          <hr>
        </div>
        <div>
          <p>邮箱： wlh@paotuanbang.cn</p>
          <hr>
        </div>
      </div>
      <img src="../../../assets/images/map.png" class="right-img">
    </div>
  </div>
</template>

<script>
import TitleText from './TitleText'

export default {
  name: 'ContactUs',
  components: {TitleText}
}
</script>

<style   lang="stylus">
  .page
    width 100%
    height 566px
    background-image url("../../../assets/images/contact-us-second-gray.png")
    background-position center
    background-size cover
    margin-bottom 175px
  .contact-us-block
    width 1070px
    margin 0 auto
    padding-top 30px
    .contact-us-title
      width 50%
      display inline-block
    .left
      width 590px
      display inline-block
      font-size 28px
      hr
        border 1.5px solid #bfbfbf
        margin 36px 0

    .right-img
      position absolute
      top 1550px
      margin-left 60px
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/components/ContactUs.vue